import http from '@/communication/AuthConnection'

export default async ({ state }, editData) => {
  const payload = {
    itemId: editData.itemId,
    description: editData.description.text || state.selectedItem.itemInfo.description,
    quantity: editData.quantity.text || state.selectedItem.itemInfo.quantity,
    estimatedPrice: editData.estimatedPrice.text || state.selectedItem.itemInfo.estimatedPrice,
    factor: editData.factor.text || state.selectedItem.itemInfo.factor,
    unity: editData.unity.text || state.selectedItem.itemInfo.unity
  }

  try {
    const result = await http.post(`/v1/item-association/edit-item`, payload)
    return result.data
  } catch (e) {
    return Promise.reject(e)
  }
}



// WEBPACK FOOTER //
// ./src/brain/item-association/EditItemData.js